var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bccffc9df1341941179e28f6e0a43291fd2f337b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby@homepl"]={id:"bccffc9df1341941179e28f6e0a43291fd2f337b"};
      